var serverUrl = process.env.REACT_APP_SERVER_URL
var weberUrl = process.env.REACT_APP_WEBER_URL
var poppernautUrl = process.env.REACT_APP_POPPERNAUT_URL
var argusUrl = process.env.REACT_APP_ARGUS_URL
var analysisTimeout = process.env.REACT_APP_ANALYSIS_TIMEOUT
var customerImageUrlPrefix = process.env.REACT_APP_CUSTOMER_IMAGE_URL_PREFIX
var customerlogoUrlPrefix = process.env.REACT_APP_CUSTOMER_LOGO_URL_PREFIX

var config = {
    serverUrl: serverUrl,
    serverBaseUrl: serverUrl,
    serverBaseUri: "/api/v1",
    serverTimeout: 3600000,  // 60 minutes
    customerImageUrlPrefix: customerImageUrlPrefix,
    customerlogoUrlPrefix: customerlogoUrlPrefix,
    fileUploadMaxRetries: 3,

    debug: "REACT_APP_DEBUG" in process.env && process.env.REACT_APP_DEBUG === "true" ? true : false,

    barcodeScanner: {
        license: process.env.REACT_APP_BARCODE_SCANNER_LICENSE,
        debug: "REACT_APP_BARCODE_SCANNER_DEBUG" in process.env && process.env.REACT_APP_BARCODE_SCANNER_DEBUG === "true" ? true : false
    },

    reduxDevTool: {
        enabled: process.env.REACT_APP_REDUX_DEVTOOL_ENABLED,
        trace: process.env.REACT_APP_REDUX_DEVTOOL_TRACE
    },

    additionalQuestions: {
        enableTriage: "REACT_APP_ENABLE_TRIAGE_FOR_ADDL_PHOTOS" in process.env
                    && process.env.REACT_APP_ENABLE_TRIAGE_FOR_ADDL_PHOTOS === "true" ? true : false,
        enableObjectDetection: "REACT_APP_ENABLE_OBJECT_DETECTION_FOR_ADDL_PHOTOS" in process.env
                    && process.env.REACT_APP_ENABLE_OBJECT_DETECTION_FOR_ADDL_PHOTOS === "true" ? true : false,
        questionType: "REACT_APP_ADDL_PHOTOS_QUESTION_TYPE" in process.env ? process.env.REACT_APP_ADDL_PHOTOS_QUESTION_TYPE : "allCameras"
    },

    imageAnalysis: {
        registration: {
            baseUrl: weberUrl,
            endpoint: "extract",
            arguments: {
                type: ["registration"]
            },
            timeout: analysisTimeout,
            callback: "handleResultAssignment"
        },
        autoDecpageExtraction: {
            baseUrl: weberUrl,
            endpoint: "extract",
            arguments: {
                type: ["auto_decpage"]
            },
            timeout: analysisTimeout,
            callback: "handleResultAssignment"
        },
        documentScan: {
            baseUrl: weberUrl,
            endpoint: "scan",
            timeout: analysisTimeout
        },
        detect: {
            baseUrl: poppernautUrl,
            endpoint: "detect",
            timeout: analysisTimeout,
            // Flag anything with a total score above this
            tamperScoreThreshold: 75,
            runInBackground: true,
            callback: "handleDetectResult"
        },
        triageFull: {
            baseUrl: poppernautUrl,
            endpoint: "detect_tampering",
            timeout: analysisTimeout,
            // Flag anything with a total score above this
            tamperScoreThreshold: 75,
            runInBackground: true,
            callback: "handleTriageResult"
        },
        triagePop: {
            baseUrl: poppernautUrl,
            endpoint: "detect_tampering",
            timeout: analysisTimeout,
            // Flag anything with a total score above this
            tamperScoreThreshold: 75,
            arguments: {
                model: ["pop"]
            },
            callback: "handleTriageResult"
        },
        objectDetection: {
            baseUrl: poppernautUrl,
            endpoint: "detect_objects",
            timeout: analysisTimeout,
            runInBackground: true,
            callback: "handleObjectDetectionResult"
        },
        facialDetection: {
            baseUrl: poppernautUrl,
            endpoint: "detect_faces",
            timeout: analysisTimeout,
            runInBackground: false,
            callback: "handleFacialDetectionResult"
        },
        receipt: {
            baseUrl: poppernautUrl,
            endpoint: "detect",
            arguments: {
                analysis_types: ["detect_expenses"]
            },
            runInBackground: false,
            timeout: analysisTimeout,
            callback: "handleExtractResult"
        },
        imeiExtraction: {
            baseUrl: weberUrl,
            endpoint: "extract",
            arguments: {
                type: ["imei"]
            },
            timeout: analysisTimeout,
            callback: "handleExtractResult"
        },
        decpageExtraction: {
            baseUrl: weberUrl,
            endpoint: "extract",
            arguments: {
                type: ["decpage"]
            },
            timeout: analysisTimeout,
            callback: "handleDecPageResult"
        },
        damageDetection: {
            baseUrl: poppernautUrl,
            endpoint: "detect_damage",
            timeout: analysisTimeout,
            callback: "handleDamageDetectionResult"
        },
        argus: {
            baseUrl: argusUrl,
            endpoint: "jobs",
            timeout: analysisTimeout,
            runInBackground: true,
            serverSide: true
        },

        // Debug module used to evaluate the triage results
        debugTriage: {
            baseUrl: poppernautUrl,
            endpoint: "detect_tampering",
            timeout: analysisTimeout,
            // Flag anything with a total score above this
            tamperScoreThreshold: 75,
            callback: "handleDebugTriageResult"
        },
        // Debug module used to evaluate pop while collecting new photos
        debugPopCollection: {
            baseUrl: poppernautUrl,
            endpoint: "pop/ingest",
            timeout: analysisTimeout,
            callback: "handlePopCollection"
        }
    }
};

module.exports = config;
